<div class="phone-input-custom" [ngClass]="inputClass">
    
    <ngx-material-intl-tel-input [preferredCountries]="preferredCountries.length > 0 ? preferredCountries : [resolvedCountryCode || defaultCountry]"
        [enablePlaceholder]="enablePlaceholder"
        [autoIpLookup]="autoIpLookup"
        [fieldControl]="innerControl"
        [required]="required"
        [disabled]="disabled"
        [appearance]="appearance"
        [autoSelectCountry]="autoSelectCountry"
        [autoSelectedCountry]="resolvedCountryCode || autoSelectedCountry || defaultCountry"
        [numberValidation]="phoneValidation"
        [enableSearch]="enableSearch"
        [includeDialCode]="includeDialCode"
        [emojiFlags]="emojiFlags"
        [visibleCountries]="visibleCountries"
        [excludedCountries]="excludedCountries"
        [initialValue]="initialValue"
        [useMask]="useMask"
        [forceSelectedCountryCode]="forceSelectedCountryCode"
        [showMaskPlaceholder]="showMaskPlaceholder"
        [enableInputMaxLength]="enableInputMaxLength"
        [localizeCountryNames]="localizeCountryNames"
        [mainLabel]="mainLabel"
        [textLabels]="textLabels"
        (blur)="onBlur()"
        placeholder="Enter phone number">
    </ngx-material-intl-tel-input>

</div>
